const Roles = {
    roles: () => 'admin/role',
    rolesById: (id: string) => `admin/role/${id}`,
}
export default Roles